import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/laboratorio';
import LaboratoriosDRCClass from './LaboratoriosDRCClass';
import './LaboratoriosDRC.css';

const ms2p = (state) => {
    const { me } = state.login;

    return {
        ...state.laboratorio,
        me,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(LaboratoriosDRCClass);
